/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Le chêne est un arbre fruitier qui produit des glands. Plusieurs espèces de chêne sont très présentes en France."), "\n", React.createElement(_components.p, null, "Sa floraison a lieu au printemps avec l’apparition des nouvelles feuilles. De grandes quantités de pollens sont alors dispersées par le vent. Le pollen du chêne est moyennement allergisant."), "\n", React.createElement(_components.p, null, "Pour savoir reconnaître le chêne, ", React.createElement(_components.a, {
    href: "https://www.vegetation-en-ville.org/wp-content/uploads/2016/05/Quercus.pdf"
  }, "consultez cette fiche"), "."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
